var React = require('react');

function NewMessageIconInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 3.312a2.2 2.2 0 0 1 2.188-2.188h5a.94.94 0 0 1 .938.938.94.94 0 0 1-.938.938h-5c-.173 0-.313.14-.313.313v12.5c0 .083.033.163.091.221s.138.091.221.091h12.5c.083 0 .163-.033.221-.091s.091-.138.091-.221v-5a.94.94 0 0 1 .938-.938.94.94 0 0 1 .938.938v5A2.2 2.2 0 0 1 14.688 18h-12.5A2.2 2.2 0 0 1 0 15.812v-12.5zM14.188.274l3.538 3.538a.94.94 0 0 1 0 1.325l-8.838 8.838c-.176.176-.414.275-.663.275H4.688a.95.95 0 0 1-.938-.938V9.775c0-.248.099-.487.275-.663L12.863.274a.94.94 0 0 1 1.325 0zm1.55 4.2l-2.212-2.212-7.9 7.9v2.212h2.212l7.9-7.9z","fill":"#269c74","fillRule":"evenodd"}));
}

NewMessageIconInline.defaultProps = {"width":"18","height":"18","xmlnsV":"https://vecta.io/nano"};

module.exports = NewMessageIconInline;

NewMessageIconInline.default = NewMessageIconInline;
